import { mapMutations, mapState } from "vuex"

export const base = Language => {
  var key = Object.keys(Language)[0]
  return {
    data () {
      return {
        resData: ""
      }
    },
    mounted () {},
    computed: {
      [key] () {
        return this.translate(this.LANGUAGE, Language[key])
      },
      ...mapState(["USER","LANGUAGE","PAGEMAXINDEX"])
    },
    methods: {
      getAjaxData (ajax, params, field) {
        this.$http(ajax, {
          //       this.getAjaxData(URL_FINDUSER,{"user_id":"1"},"msg")
          params
        }).then(res => {
          this.resData = res.data
        })
      },
      ...mapMutations([
        "SAVEUSER",
        "SAVELANGUAGE",
        "SAVEPAGEMAXINDEX"
      ])
    },
    watch: {}
  }
}



// WEBPACK FOOTER //
// ./src/common/mixin/base.js